import React from 'react';
import styled from 'styled-components';

import { ACTIVITY_LABELS } from '../../../utils/socChartUtils';
import { SpacerHr } from '../../Styled';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 14px;
  text-align: left;

  th,
  td {
    padding: 12px;
  }

  th {
    font-weight: bold;
    vertical-align: top;
  }

  tr:nth-child(even) {
    background-color: ${(props) => props.theme.colors.extraLight};
  }
`;

const ActivityDescriptionList = styled.dl`
  margin: 0;
  dt {
    font-weight: 600;
    margin-top: 12px;
    &:first-child {
      margin-top: 0;
    }
  }
  dd {
    margin-left: 0;
    margin-bottom: 4px;
    font-size: 14px;
  }
`;

type HistoricRow = { x: string; y: number };

type Props = {
  historicChartData: HistoricRow[] | null | undefined;
};

export const HistoricChangesContent: React.FC<Props> = ({ historicChartData }) => (
  <div>
    <StyledTable>
      <thead>
        <tr>
          <th>Time</th>
          <th className="text-right">Target charge</th>
        </tr>
      </thead>
      <tbody>
        {historicChartData ? (
          historicChartData.map((row) => (
            <tr key={`row-${row.x}`}>
              <td>{row.x}</td>
              <td className="text-right">{Math.round(row.y)}%</td>
            </tr>
          ))
        ) : (
          <tr>
            <td>---</td>
            <td className="text-right">---</td>
          </tr>
        )}
      </tbody>
    </StyledTable>
  </div>
);

export const ActivityDescriptionsContent: React.FC = () => (
  <ActivityDescriptionList>
    <dt>{ACTIVITY_LABELS.gridCharge}</dt>
    <dd>The battery charges using cheap electricity from the grid to save money.</dd>
    <dt>{ACTIVITY_LABELS.solarCharge}</dt>
    <dd>The battery charges using energy generated by your solar panels.</dd>
    <dt>{ACTIVITY_LABELS.consumption}</dt>
    <dd>Stored energy is used to power your home instead of importing from the grid.</dd>
    <dt>{ACTIVITY_LABELS.export}</dt>
    <dd>Stored energy is sold back to the grid when electricity prices are high.</dd>
    <dt>{ACTIVITY_LABELS.idle}</dt>
    <dd>The battery holds its current charge level, waiting for the best time to act.</dd>
  </ActivityDescriptionList>
);

type DisabledProps = {
  appName: string;
};

export const DisabledChangesContent: React.FC<DisabledProps> = ({ appName }) => (
  <div>
    <StyledTable className="mb-0">
      <thead>
        <tr>
          <th>Time</th>
          <th className="text-right">Target charge</th>
        </tr>
      </thead>
    </StyledTable>
    <SpacerHr />
    <div className="text-center font-italic mb-3">{appName} is off</div>
  </div>
);
